import { render, staticRenderFns } from "./telzx.vue?vue&type=template&id=81d916de&scoped=true&"
import script from "./telzx.vue?vue&type=script&lang=js&"
export * from "./telzx.vue?vue&type=script&lang=js&"
import style0 from "./telzx.vue?vue&type=style&index=0&id=81d916de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d916de",
  null
  
)

export default component.exports